module.exports = __webpack_public_path__ + "img/LU.3015a21a.svg";